<template>
    <v-card flat>
        <v-card-text>
            <div class="bg-white" style="max-height: 18rem;overflow: auto;direction: ltr;text-align: left">
                <div v-for="group in emojiGroup" :key="group" class="row mx-auto">
                    <div class="col-12">
                        <h5>{{ group }}</h5>

                        <hr>
                    </div>

                    <div v-for="emoji in emojis.filter(emoji=>emoji.group===group)"
                         style="color: black;cursor: pointer"
                         class="col fa-2x"
                         :data-slug="emoji.slug"
                         @click="selectEmoji(emoji.icon)">
                        {{ emoji.icon }}
                    </div>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "emojiSelector",
    props: {
        inputBox: {
            require: true
        },
    },
    data() {
        return {
            menu: false,
            emojis: require('./emoji.json')
        }
    },
    methods: {
        selectEmoji(emoji) {
            const selector = this.inputBox;

            let currentInput = selector.value;
            let startPosition = selector.$el.querySelector('textarea').selectionStart;
            let endPosition = selector.$el.querySelector('textarea').selectionEnd;
            let textBefore = currentInput.substring(0, startPosition);
            let textAfter = currentInput.substring(endPosition, currentInput.length);

            selector.$emit('input', textBefore + emoji + textAfter);

            this.$nextTick(function () {
                selector.focus();
                selector.$el.querySelector('textarea').setSelectionRange(startPosition, startPosition);
            })
        }
    },
    computed: {
        emojiGroup() {
            let groups = [];

            this.emojis.forEach(emoji => {
                if (groups.indexOf(emoji.group) < 0)
                    groups.push(emoji.group);
            });

            return groups;
        }
    }
}
</script>

<style scoped>

</style>